module.exports = __webpack_public_path__ + "img/logo-fifalotto-white5-lottopyn.26ce7304.png";